import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getFirstFocusable } from 'src/scripts/utilities/focusableElementUtils';
import api from '@utils/api';
import classNames from 'classnames';
import { getStep } from '@state/features/accordion.selectors';
import { AccordionStepsActionTypes } from '@state/features/common.types';
import { Form } from 'react-final-form';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import FormField from '@ui/formfield/FormField';
import Loading from '@ui/loading/Loading';
import formutils from '@utils/formutils';
import urlUtils from '@utils/urlUtils';
const addressfields = ['profiling', 'marketingPurposes', 'marketingInitiatives', 'ownDevice'];
const ConnectivityCheckoutStepReview = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { paymentData, registry, policies } = useSelector((state) => state.connectivity);
    const step = useSelector(getStep) || 'personalData';
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const reviewFormRef = useRef(null);
    useEffect(() => {
        if (!registry) {
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: 'personalData' });
        }
        else if (!paymentData || !paymentData.paymentMethod) {
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: 'payment' });
        }
    }, []);
    useEffect(() => {
        let val = {};
        api.getForm('connectivityReview', val).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
    }, []);
    const onSubmit = async (values) => {
        props.setErrors([]);
        urlUtils.removeErrorParamCheckout(step);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        let policiesObj = {};
        if (policies && policies.length > 0) {
            policies.forEach((policy) => {
                if (policy.products && policy.products.length > 0) {
                    policiesObj[policy.ID.toLowerCase()] = policy.products.map((product) => {
                        return {
                            id: product.id,
                            name: product.name,
                            checked: reviewFormRef.current.elements[policy.ID.toLowerCase()].checked
                        };
                    });
                }
                else {
                    policiesObj[policy.ID.toLowerCase()] = reviewFormRef.current.elements[policy.ID.toLowerCase()].checked;
                }
            });
        }
        return api
            .connectivityPlaceOrder(values, formdef, Object.assign({}, policiesObj))
            .then((data) => {
            if (data.error) {
                if (data.errorMessage) {
                    props.setErrors([data.errorMessage]);
                }
                if (data.redirectUrl) {
                    location.href = data.redirectUrl;
                    return;
                }
                return;
            }
            if (data.continueUrl) {
                let form = document.createElement('form');
                let emailInput = document.createElement('input');
                emailInput.type = 'hidden';
                emailInput.name = 'registryEmail';
                emailInput.value = data.registryEmail;
                form.method = 'POST';
                form.action = data.continueUrl;
                form.appendChild(emailInput);
                document.body.appendChild(form);
                form.submit();
            }
        })
            .catch((e) => props.setErrors([e]));
    };
    const validate = async (values) => {
        let errors = await formutils.validateForm(values, formdef, 'connectivityReview');
        if (policies && policies.length > 0) {
            policies.forEach((policy) => {
                if (policy.mandatory) {
                    if (!values[policy.ID.toLowerCase()]) {
                        errors[policy.ID.toLowerCase()] = t('required.field');
                    }
                }
            });
        }
        return errors;
    };
    const printMarketingOption = (option) => {
        return {
            value: option,
            label: (React.createElement("span", { key: option, className: classNames('radio-marketing') }, option === 'yes' ? t('common.yes') : t('common.no'))),
            content: (React.createElement(React.Fragment, null)),
            checked: false
        };
    };
    const printInstallationOption = (option) => {
        return {
            value: option.value,
            label: (React.createElement("span", { key: option.value, className: 'option-device-label' }, option.label))
        };
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "checkout-connectivity--review" },
        React.createElement("div", { className: 'checkout-connectivity-review' },
            React.createElement("p", { className: 'checkout-step-description' }, t('connectivity.checkout.review.description')),
            React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, validate: validate, mutators: {
                    global: formutils.globalMutator,
                    setValue: ([selected], state, { changeValue }) => {
                        addressfields.forEach((f) => {
                            changeValue(state, f, () => selected[f]);
                        });
                        // console.log('setValue ' + key + '=' + value);
                    },
                }, render: ({ handleSubmit, errors, form, submitting, pristine, values }) => (React.createElement("form", { id: 'review-form', onSubmit: (e) => {
                        handleSubmit(e);
                        if (errors && Object.keys(errors).length > 0) {
                            setTimeout(() => {
                                var _a;
                                const invalidElements = (_a = reviewFormRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.is-invalid');
                                if ((invalidElements === null || invalidElements === void 0 ? void 0 : invalidElements.length) > 0) {
                                    invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    setTimeout(() => { var _a; return (_a = getFirstFocusable(invalidElements[0])) === null || _a === void 0 ? void 0 : _a.focus(); }, 500);
                                }
                            }, 150);
                        }
                    }, ref: reviewFormRef },
                    policies && policies.length > 0 && (React.createElement("div", { className: 'policies--section' },
                        React.createElement("div", { className: 'policies--container' }, policies.map((policy) => React.createElement(FormField, { type: 'checkbox', name: policy.ID.toLowerCase(), label: policy.products && policy.products.length > 0 ? `<span>${policy.text} ${policy.products.map((product, index) => `<a href=${product.url} class='link-default' target="_blank">${product.name}</a>${policy.products.length > 1 && (index + 1) !== policy.products.length ? ', ' : ''}`).join('')} ${policy.mandatory ? '(*)' : ''}</span>` : policy.text && policy.url ? `<span>${policy.text} <a href="${policy.url}" class="link-default" target="_blank">${policy.name}</a> ${policy.mandatory ? '(*)' : ''}</span>` : `<span>${policy.text} ${policy.mandatory ? '(*)' : ''}</span>`, required: policy.mandatory, ispolicy: true, key: policy.ID }))))),
                    React.createElement("div", { className: 'device--section' },
                        React.createElement("p", { className: 'info-label' }, t('connectivity.checkout.review.device.label')),
                        React.createElement("div", { className: 'device--options' },
                            React.createElement(DwFormField, { def: formdef, name: 'ownDevice', type: 'radio', groupClassName: 'boxed-radio', options: [{ value: 'iren', label: t('connectivity.checkout.review.device.iren') }, { value: 'user', label: t('connectivity.checkout.review.device.user') }].map((option) => printInstallationOption(option)) }))),
                    React.createElement("div", { className: 'marketing--section' },
                        React.createElement("p", { className: 'marketing--title' },
                            React.createElement("span", null, t('checkout.payment.marketing.title')),
                            React.createElement("span", null,
                                React.createElement("svg", { className: `icon--user-black icon--s no-stroke`, "aria-hidden": "true" },
                                    React.createElement("use", { href: `#sprite-user-black` })))),
                        React.createElement("p", { className: 'marketing--label', dangerouslySetInnerHTML: { __html: t('checkout.payment.marketing.profiling', { '0': props.profilingurl }) } }),
                        React.createElement(DwFormField, { def: formdef, name: "profiling", type: 'radio', groupClassName: "boxed-radio", options: ['yes', 'no'].map(option => printMarketingOption(option)) }),
                        React.createElement("p", { className: 'marketing--label', dangerouslySetInnerHTML: { __html: t('checkout.payment.marketing.marketingpurposes', { '0': props.marketingpurposesurl }) } }),
                        React.createElement(DwFormField, { def: formdef, name: "marketingPurposes", type: 'radio', groupClassName: "boxed-radio", options: ['yes', 'no'].map(option => printMarketingOption(option)) }),
                        React.createElement("p", { className: 'marketing--label', dangerouslySetInnerHTML: { __html: t('checkout.payment.marketing.marketinginitiatives', { '0': props.marketinginitiativesurl }) } }),
                        React.createElement(DwFormField, { def: formdef, name: "marketingInitiatives", type: 'radio', groupClassName: "boxed-radio", options: ['yes', 'no'].map(option => printMarketingOption(option)) })),
                    React.createElement("p", { className: 'info-mandatory-label' }, t('label.info.mandatory')),
                    React.createElement("div", { className: 'checkout-navigations' },
                        React.createElement(Button, { type: "submit", cls: ['cta-primary'], isAnimated: true, style: { pointerEvents: submitting ? 'none' : 'initial', cursor: submitting ? 'not-allowed' : 'pointer' } },
                            submitting && React.createElement(Loading, { inline: true }),
                            React.createElement("span", { style: { opacity: submitting ? 0 : 1 } }, t('checkout.pay')))))) }))));
};
export default ConnectivityCheckoutStepReview;
